import { type FC } from 'react';
import cn from 'classnames';

import { getImage } from '@/common/lib/images';
import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { type PromoCodeRewardState } from '@/common/types/shop/promo';
import { LightColorEffect } from '@/components/common/LightColorEffect/LightColorEffect';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import dicePng from '/img/dice-game/dice.png';
import diceWebp from '/img/dice-game/dice.webp';
import cashPng from '/img/icons/cash-large.png';
import cashWebp from '/img/icons/cash-large.webp';
import usdtPng from '/img/icons/usd-star-icon.png';
import usdtWebp from '/img/icons/usd-star-icon.webp';
import diamondPng from '/img/lottery/diamond.png';
import diamondWebp from '/img/lottery/diamond.webp';
import goldPng from '/img/lottery/gold.png';
import goldWebp from '/img/lottery/gold.webp';
import silverPng from '/img/lottery/silver.png';
import silverWebp from '/img/lottery/silver.webp';
import tgemPng from '/img/tgem-3d.png';
import tgemWebp from '/img/tgem-3d.webp';
import crownPng from '/img/VIP/crown.png';
import crownWebp from '/img/VIP/crown.webp';

const PromoCodeReward: FC<PromoCodeRewardState> = ({ item, value }) => {
  const rewardImages = {
    dice: {
      img: dicePng,
      webp: diceWebp,
    },
    tgem: {
      img: tgemPng,
      webp: tgemWebp,
    },
    vip: {
      img: crownPng,
      webp: crownWebp,
    },
    usdt: {
      img: usdtPng,
      webp: usdtWebp,
    },
    cash: {
      img: cashPng,
      webp: cashWebp,
    },
    silverTicket: {
      img: silverPng,
      webp: silverWebp,
    },
    goldTicket: {
      img: goldPng,
      webp: goldWebp,
    },
    diamondTicket: {
      img: diamondPng,
      webp: diamondWebp,
    },
  };

  const whiteLight = ['silverTicket', 'goldTicket', 'diamondTicket', 'vip'];

  const image =
    item in rewardImages
      ? rewardImages[item as keyof typeof rewardImages]
      : getImage({ name: item, field: 'icon' });

  return (
    <>
      <div className="relative aspect-square w-24 mb-4">
        <LightColorEffect
          lightClassName={cn(
            whiteLight.includes(item) ? css.whiteEffect : css.blueEffect,
          )}
          className="absolute -z-[1] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 aspect-[364/260] w-[22.75rem]"
        />
        <Picture
          {...image}
          className={cn(
            'aspect-square w-full block',
            // reward === 'tgem' && css.rewardImage,
          )}
          alt={item}
        />
      </div>
      <span className="text-[2.5rem] leading-none font-extrabold mb-[5.25rem]">{`+${item === 'vip' ? value + 'h' : toShortNumFormat(value)}`}</span>
    </>
  );
};

export { PromoCodeReward };
